import apiClient from '../axios'

export async function all() {
  return apiClient
    .get(`/roles/all`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function list(page) {
  return apiClient
    .get(`/roles?page=${page}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function details(id) {
  return apiClient
    .get(`/roles/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function add(data) {
  return apiClient
    .put('/roles', data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function edit(id, data) {
  return apiClient
    .post(`/roles/${id}`, data)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}

export async function remove(id) {
  return apiClient
    .delete(`/roles/${id}`)
    .then(response => {
      if (response) {

        return response
      }
      return false
    })
    .catch(err => err && err);
}
